import { Component, computed, input, output } from '@angular/core';
import { canNavigateNext, canNavigatePrevious, clampDateToRange } from './definitions';
import { PriceFilter, getSelectedFrom, getSelectedTo } from '../../stores/price.store';
import { addDays, addMonths, addWeeks, addYears } from 'date-fns';
import { Button, Toggle, ToggleLabel } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-analysis-price-filters',
  templateUrl: './analysis-price-filters.html',
  imports: [Button, Toggle, ToggleLabel, NgIcon, TranslocoPipe, DatePipe],
})
export class AnalysisPriceFilters {
  filter = input.required<PriceFilter>();
  changeFilter = output<PriceFilter>();

  protected granularity = computed(() => this.filter().granularity);
  protected date = computed(() => this.filter().date);
  protected selectedFrom = computed(() => getSelectedFrom(this.filter()));
  protected selectedTo = computed(() => getSelectedTo(this.filter()));
  protected isPreviousDisabled = computed(
    () => !canNavigatePrevious(this.date(), this.granularity()),
  );
  protected isNextDisabled = computed(() => !canNavigateNext(this.date(), this.granularity()));
  protected showEurMwh = computed(() => this.filter().showEurMwh);

  protected onToggleEurMwh(checked: boolean) {
    this.onChangeFilter({ showEurMwh: checked });
  }

  protected onClickNextButton() {
    const selectedDate = this.date();
    switch (this.granularity()) {
      case 'YEAR': {
        this.onChangeFilter({ date: addYears(selectedDate, 1) });
        break;
      }
      case 'MONTH': {
        this.onChangeFilter({ date: addMonths(selectedDate, 1) });
        break;
      }
      case 'WEEK': {
        this.onChangeFilter({ date: addWeeks(selectedDate, 1) });
        break;
      }
      case 'DAY': {
        this.onChangeFilter({ date: addDays(selectedDate, 1) });
        break;
      }
    }
  }

  protected onClickPreviousButton() {
    const selectedDate = this.date();
    switch (this.granularity()) {
      case 'YEAR': {
        this.onChangeFilter({ date: addYears(selectedDate, -1) });
        break;
      }
      case 'MONTH': {
        this.onChangeFilter({ date: addMonths(selectedDate, -1) });
        break;
      }
      case 'WEEK': {
        this.onChangeFilter({ date: addWeeks(selectedDate, -1) });
        break;
      }
      case 'DAY': {
        this.onChangeFilter({ date: addDays(selectedDate, -1) });
        break;
      }
    }
  }

  protected onClickTodayButton() {
    this.onChangeFilter({ date: new Date() });
  }

  protected onChangeFilter(filter: Partial<PriceFilter>) {
    const current = this.filter();
    const merged = {
      ...current,
      ...filter,
    };
    if (merged.date) {
      merged.date = clampDateToRange(merged.date);
    }
    this.changeFilter.emit(merged);
  }
}
